import { getPageAllowedRoles } from "../../config/roles";
import { fullWidth } from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import { AdvancedSearchPanel } from "./AdvancedSearchPanel";

/** Advanced search over contacts and their audits, with actions on the results. */
export const searchPageDefinition: PageDefinition = {
  path: "/search",
  title: "Search",
  allowedRoles: getPageAllowedRoles("search"),
  fill: true,
  rows: [
    {
      id: "row-search",
      panels: [
        {
          id: "panel-search",
          title: "",
          span: fullWidth,
          component: AdvancedSearchPanel,
        },
      ],
    },
  ],
};
